module.exports = __webpack_public_path__ + "static/media/foto8.31df43a7.jpeg";